import { shortHumanizer } from '@/utils';

export const pipelineFn = (orderBy, order, page, rowsPerPage, query) => [
  { $match: query },
  {
    $project: {
      identifier: true,
      startTime: true,
      endTime: true,
      durationSeconds: true,
      distanceMiles: { $multiply: ['$distanceKilometres', 0.62137119] },
      location: true,
      vehicle: true,
    },
  },
  { $sort: { [orderBy]: order === 'desc' ? -1 : 1 } },
  { $skip: page * rowsPerPage },
  { $limit: rowsPerPage },
];

export const downloadPipelineFn = (query) => [
  { $match: query },
  {
    $project: {
      identifier: true,
      startTime: true,
      endTime: true,
      durationSeconds: { $divide: ['$durationSeconds', 86400] },
      distanceMiles: {
        $round: [{ $multiply: ['$distanceKilometres', 0.62137119] }, 2],
      },
      location: true,
      vehicle: true,
    },
  },
];

export const headers = [
  {
    label: 'Registration',
    key: 'vehicle.registrationNumber',
    type: 'text',
  },
  {
    label: 'Fleet Number',
    key: 'vehicle.fleetNumber',
    type: 'text',
  },
  {
    label: 'Role',
    key: 'vehicle.role',
    type: 'text',
  },
  {
    label: 'Division',
    key: 'vehicle.groups.division',
    type: 'text',
  },
  { label: 'Type', key: 'vehicle.type', type: 'text' },
  { label: 'Location Type', key: 'location.type', type: 'text' },
  {
    label: 'Location Subtype',
    key: 'location.subtype',
    type: 'text',
  },
  { label: 'Location Name', key: 'location.name', type: 'text' },
  { label: 'Start Time', key: 'startTime', type: 'date' },
  { label: 'End Time', key: 'endTime', type: 'date' },
  {
    label: 'Duration',
    key: 'durationSeconds',
    format: (value) => shortHumanizer(value * 1000),
    type: 'text',
    align: 'right',
    filter: false,
  },
  {
    label: 'Distance (miles)',
    key: 'distanceMiles',
    type: 'number',
    filter: false,
  },
];
